import _ from "lodash";
import axios from "axios";
import {
  getRequest,
  postRequest,
  deleteRequest,
  deleteBulkRequest,
  fileUploadRequest,
  patchRequest,
  uploadEncodedFile,
} from "NetworkCall";
import { getHeaders } from "CommonUtils";
import { randomstring } from "randomstring-js";
import {
  FETCH_SESSION_COLORS,
  FETCH_SCHEDULES_DATA_PENDING,
  FETCH_SCHEDULES_DATA_FULFILLED,
  FETCH_SCHEDULES_DATA_REJECTED,
  OPEN_TRACK_MODAL,
  OPEN_SESSION_MODAL,
  SELECT_SCHEDULE_DATE,
  OPEN_SESSION_PRIVATE_USER_MODAL,
  UPDATE_SESSION_FILES,
} from "ScheduleConstants";
import {
  SELECTED_CONTENT_FEATURE,
  INSTANCE_URL,
  EDIT_CONTENT_ICON_NAME,
  FILES_UPLOAD_FAILED,
  UPDATE_FILES_UPLOAD_PROGRESS,
  BASE_IMAGES_URL,
  APP_API_KEY,
  MAIN_URL,
} from "Constants";
export var FEATURES_MODAL = "FEATURES_MODAL";
export var CONTENT_ADD_REMOVE_MODAL = "CONTENT_ADD_REMOVE_MODAL";
export var SESSION_WEEKDAYS = "SESSION_WEEKDAYS";
export var SESSION_DEFAULT_TRACK = "SESSION_DEFAULT_TRACK";
export var ACTIVE_DATE_ALL_SESSION = "ACTIVE_DATE_ALL_SESSION";
export var ALL_ADDITIONAL_SESSIONS = "ALL_ADDITIONAL_SESSIONS";
export var IMPORT_SCHEDULE_MODAL = "IMPORT_SCHEDULE_MODAL";
export var SESSION_ASSOCIATED_USERS = "SESSION_ASSOCIATED_USERS";
export var SESSION_RSVP_USERS = "SESSION_RSVP_USERS";
export var SCHEDULES_ASSIGNED_SPEAKERS = "SCHEDULES_ASSIGNED_SPEAKERS";
export var SESSION_SCREEN_ZOOM = "SESSION_SCREEN_ZOOM";
export const BULLKEDIT_MODAL_CONTROL = "BULLKEDIT_MODAL_CONTROL";

export function selectContentFeature(contentFeature) {
  return {
    type: SELECTED_CONTENT_FEATURE,
    payload: contentFeature,
  };
}

export function toggleEditContentTabNameEditor(show) {
  return {
    type: EDIT_CONTENT_ICON_NAME,
    payload: show,
  };
}

export function updateContentTabName(session, values, callback) {
  return (dispatch) => {
    var url = `${INSTANCE_URL}/api/v2/eventify/_table/apptabs?fields=*`;
    values["eventid"] = session.eventid;
    var validJson = { resource: [{ ...values }] };
    patchRequest(
      url,
      validJson,
      session,
      dispatch,
      (response) => {
        callback({ error: 0, data: response });
      },
      (error) => {
        callback({ error: 1, data: "" });
      }
    );
  };
}

export function fetchSessionColors(session) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/sessioncolors`;

  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (data) => {
        dispatch({ type: FETCH_SESSION_COLORS, payload: data });
      },
      (error) => {}
    );
  };
}

export function fetchScheduleData(session, callback) {
  // var url = `${INSTANCE_URL}/api/v2/eventify/_table/event?fields=eventid&related=session_by_eventid,appuser_access_by_eventid,appuser_by_eventid,scheduledates_by_eventid,speaker_by_eventid,sessionspeakers_by_eventid&appuser_by_eventid.fields=appuserid,email,username&speaker_by_eventid.fields=speakerid,email,firstname,lastname&filter=(eventid%3D${session.eventid})`;
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/event?fields=eventid&related=session_by_eventid,scheduledates_by_eventid,speaker_by_eventid,sessionspeakers_by_eventid&speaker_by_eventid.fields=speakerid,email,firstname,lastname&filter=(eventid%3D${session.eventid})`;

  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (data) => {
        dispatch({ type: FETCH_SCHEDULES_DATA_FULFILLED, payload: data });
        // debugger;
        var responseData = data.resource[0];
        var dates = [];
        if (responseData.scheduledates_by_eventid)
          var scheduledates = responseData.scheduledates_by_eventid.filter(
            (date) => date.isactive
          );
        var sortArrAvailable = _.sortBy(scheduledates, "scheduledate", "asc");
        dates = sortArrAvailable;

        var selectedDate = dates[0];
        if (selectedDate) dispatch(selectScheduleDate(selectedDate));
        callback({ success: 1 });
      },
      (error) => {
        callback({ success: 0 });
        dispatch({ type: FETCH_SCHEDULES_DATA_REJECTED });
      }
    );
  };
}

export function fetchSessionQr(session, item, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventqr?service=sessionqr`;
  let body = { sessionid: item.sessionid, eventid: item.eventid };

  return (dispatch) => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      (response) => {
        // console.log("response", response);
        callback({ success: 1, data: response });
      },
      (error) => {
        // console.log("error", error);
        callback({ success: 0, message: error });
      }
    );
  };
}

export function downloadSessionPdf(sessionid, callback) {
  // console.log('sessionid',session)
  var config = {
    headers: {
      "Access-Control-Allow-Origin": "*",
      "Access-Control-Allow-Methods": "GET, POST, PATCH, PUT, DELETE, OPTIONS",
      "Access-Control-Allow-Headers": "Origin, Content-Type",
      "content-Type": "application/x-www-form-urlencoded",
      "X-DreamFactory-Api-Key": APP_API_KEY,
    },
  };
  var url = `${MAIN_URL}/pdfgenerate/sessionqrpdf.php`;

  var body = { sessionid: sessionid };

  var response = axios.post(url, body, config);
  return (dispatch) => {
    response
      .then(({ data }) => {
        callback({ success: 1, message: data });
      })
      .catch((error) => {
        callback({ success: 0, message: error });
      });
  };
}

// This function is used to handle spekers assigned to session
export function updateSpeakerAssociate(data) {
  return (dispatch) => {
    dispatch({ type: SCHEDULES_ASSIGNED_SPEAKERS, payload: data });
  };
}

export function initiateFetchData() {
  return (dispatch) => {
    dispatch({ type: FETCH_SCHEDULES_DATA_PENDING });
  };
}

export function importScheduleModal(obj) {
  return { type: IMPORT_SCHEDULE_MODAL, payload: obj };
}

export function importSchedules(session, values, duplicateData, callback) {
  let eventid = session.eventid;
  var url = `${INSTANCE_URL}/api/v2/bulkuploadData`;
  var body = {
    list: values,
    eventid: eventid,
    action: duplicateData,
    source: "schedule",
  };

  return (dispatch) => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      (response) => {
        // console.log("response", response);
        if (response.success) {
          callback({ success: 1, count: response.count });
        } else {
          callback({ success: 2, message: response.message });
        }
      },
      (error) => {
        // console.log("error", error);
        callback({ success: 0, message: error });
      }
    );
  };
}

export function fetchAndRefreshScheduleData(session, selectedScheduleDateID) {
  // var url = `${INSTANCE_URL}/api/v2/eventify/_table/event?fields=eventid&related=session_by_eventid,appuser_access_by_eventid,appuser_by_eventid,scheduledates_by_eventid,speaker_by_eventid,sessionspeakers_by_eventid&appuser_by_eventid.fields=appuserid,email,username&speaker_by_eventid.fields=speakerid,email,firstname,lastname&filter=(eventid%3D${session.eventid})`;
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/event?fields=eventid&related=session_by_eventid,scheduledates_by_eventid,speaker_by_eventid,sessionspeakers_by_eventid&speaker_by_eventid.fields=speakerid,email,firstname,lastname&filter=(eventid%3D${session.eventid})`;

  return (dispatch) => {
    dispatch({ type: FETCH_SCHEDULES_DATA_PENDING });
    getRequest(
      url,
      session,
      dispatch,
      (data) => {
        dispatch({ type: FETCH_SCHEDULES_DATA_FULFILLED, payload: data });
        var scheduleData = data.resource[0];
        var selectedDate = scheduleData.scheduledates_by_eventid.filter(
          (date) => date.scheduledateid === selectedScheduleDateID
        )[0];
        if (selectedDate)
          dispatch({ type: SELECT_SCHEDULE_DATE, payload: selectedDate });
      },
      (error) => {
        dispatch({ type: FETCH_SCHEDULES_DATA_REJECTED });
      }
    );
  };
}

export function deleteTrack(session, track, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/scheduletracks/${track.scheduletrackid}`;
  return (dispatch) => {
    deleteRequest(
      url,
      session,
      dispatch,
      (data) => {
        callback({ error: 0, data: data });
        dispatch(fetchAndRefreshScheduleData(session, track.scheduledateid));
      },
      (error) => {
        callback({ error: 1, data: error });
      }
    );
  };
}

export function addScheduleTrack(track, session, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/scheduletracks`;

  var trackJson = { resource: { ...track, eventid: session.eventid } };
  var response = axios.post(url, trackJson, getHeaders(session));

  return (dispatch) => {
    response
      .then(({ data }) => {
        dispatch(fetchAndRefreshScheduleData(session, track.scheduledateid));
        var returnData = { error: 0, data: data };
        callback(returnData);
      })
      .catch((error) => {
        var returnData = { error: 1, data: error };
        callback(returnData);
      });
  };
}

export function updateScheduleTrack(track, session, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/scheduletracks`;

  var trackJson = { resource: { ...track, eventid: session.eventid } };
  var response = axios.patch(url, trackJson, getHeaders(session));

  return (dispatch) => {
    response
      .then(({ data }) => {
        dispatch(fetchAndRefreshScheduleData(session, track.scheduledateid));
        var returnData = { error: 0, data: data };
        callback(returnData);
      })
      .catch((error) => {
        var returnData = { error: 1, data: error };
        callback(returnData);
      });
  };
}

export function deleteSchedule(session, schedule, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/session/${schedule.sessionid}`;
  return (dispatch) => {
    deleteRequest(
      url,
      session,
      dispatch,
      (data) => {
        callback({ error: 0, data: data });
        dispatch(fetchAndRefreshScheduleData(session, schedule.scheduledateid));
      },
      (error) => {
        callback({ error: 1, data: error });
      }
    );
  };
}

export function deleteAllSchedule(session, type, callback) {
  var filter = encodeURI(`filter=(eventid=${session.eventid})`);
  var url = "";
  if (type == "sessions") {
    url = `${INSTANCE_URL}/api/v2/eventify/_table/session?${filter}`;
  } else {
    url = `${INSTANCE_URL}/api/v2/eventify/_table/scheduletracks?${filter}`;
  }

  return (dispatch) => {
    deleteRequest(
      url,
      session,
      dispatch,
      (data) => {
        callback({ error: 0, data: data });
        dispatch(fetchScheduleData(session));
      },
      (error) => {
        callback({ error: 1, data: error });
      }
    );
  };
}

export function addScheduleSession(
  scheduleSession,
  uploadFiles,
  session,
  refresh,
  callback
) {
  let coverImage = scheduleSession.coverimagehidden
    ? scheduleSession.coverimagehidden
    : "";
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/session`;

  return (dispatch) => {
    _sessionTicketCreateUpdate(
      scheduleSession,
      session,
      dispatch,
      (ticketRes) => {
        if (!ticketRes.success) {
          callback({ error: 2 });
        } else {
          scheduleSession = {
            ...scheduleSession,
            ticketid: ticketRes.ticketid,
          };

          _uploadSessionBanner(session, coverImage, dispatch, (banner) => {
            if (!banner.success) {
              callback({ error: 3 });
            } else {
              scheduleSession = {
                ...scheduleSession,
                coverimage: banner.data.path,
              };

              _uploadAttachedFiles(
                session,
                uploadFiles,
                dispatch,
                (attachments) => {
                  scheduleSession = {
                    ...scheduleSession,
                    file1: attachments[0].file,
                    file2: attachments[1].file,
                    file3: attachments[2].file,
                    file4: attachments[3].file,
                    file5: attachments[4].file,
                  };

                  var sessionJson = {
                    resource: { ...scheduleSession, eventid: session.eventid },
                  };
                  var response = axios.post(
                    url,
                    sessionJson,
                    getHeaders(session)
                  );

                  response
                    .then(({ data }) => {
                      // if(refresh)
                      // dispatch(fetchAndRefreshScheduleData(session,scheduleSession.scheduledateid));
                      var returnData = { error: 0, data: data };
                      callback(returnData);
                    })
                    .catch((error) => {
                      var returnData = { error: 1, data: error };
                      callback(returnData);
                    });
                }
              );
            }
          });
        }
      }
    );
  };
}

export function updateScheduleSession(
  scheduleSession,
  uploadFiles,
  session,
  callback
) {
  let coverImage = scheduleSession.coverimagehidden
    ? scheduleSession.coverimagehidden
    : "";
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/session`;

  return (dispatch) => {
    _sessionTicketCreateUpdate(
      scheduleSession,
      session,
      dispatch,
      (ticketRes) => {
        if (!ticketRes.success) {
          callback({ error: 2 });
        } else {
          scheduleSession = {
            ...scheduleSession,
            ticketid: ticketRes.ticketid
              ? ticketRes.ticketid
              : scheduleSession.ticketid,
          };
          _uploadSessionBanner(session, coverImage, dispatch, (banner) => {
            if (!banner.success) {
              callback({ error: 3 });
            } else {
              scheduleSession = {
                ...scheduleSession,
                coverimage: banner.data.path,
              };
              _uploadAttachedFiles(
                session,
                uploadFiles,
                dispatch,
                (attachments) => {
                  scheduleSession = {
                    ...scheduleSession,
                    file1: attachments[0].file,
                    file2: attachments[1].file,
                    file3: attachments[2].file,
                    file4: attachments[3].file,
                    file5: attachments[4].file,
                  };

                  var sessionJson = {
                    resource: { ...scheduleSession, eventid: session.eventid },
                  };
                  var response = axios.patch(
                    url,
                    sessionJson,
                    getHeaders(session)
                  );

                  response
                    .then(({ data }) => {
                      // dispatch(fetchAndRefreshScheduleData(session,scheduleSession.scheduledateid));
                      var returnData = { error: 0, data: data };
                      callback(returnData);
                    })
                    .catch((error) => {
                      var returnData = { error: 1, data: error };
                      callback(returnData);
                    });
                }
              );
            }
          });
        }
      }
    );
  };
}

export function _sessionTicketCreateUpdate(
  values,
  session,
  dispatch,
  callback
) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/tickets`;

  if (values.sessiontype === "additional") {
    if (values.sessionid && values.ticketid && values.ticketid != "") {
      // Update ticket
      var body = {
        resource: {
          id: values.ticketid,
          ticketname: values.title,
          tickettype:
            values.sessionprice &&
            values.sessionprice != "" &&
            values.sessionprice > 0
              ? "paid"
              : "free",
          currency:
            values.sessionprice &&
            values.sessionprice != "" &&
            values.sessionprice > 0
              ? "USD"
              : "",
          price:
            values.sessionprice &&
            values.sessionprice != "" &&
            values.sessionprice > 0
              ? values.sessionprice
              : 0,
          eventid: values.eventid,
          updatedby: session.userid,
        },
      };

      patchRequest(
        url,
        body,
        session,
        dispatch,
        (data) => {
          callback({ success: 1, ticketid: data.resource[0].id });
        },
        (error) => {
          callback({ success: 0 });
        }
      );
    } else {
      // Create new
      var body = {
        resource: {
          type: "session",
          ticketname: values.title,
          tickettype:
            values.sessionprice &&
            values.sessionprice != "" &&
            values.sessionprice > 0
              ? "paid"
              : "free",
          currency:
            values.sessionprice &&
            values.sessionprice != "" &&
            values.sessionprice > 0
              ? "USD"
              : "",
          price:
            values.sessionprice &&
            values.sessionprice != "" &&
            values.sessionprice > 0
              ? values.sessionprice
              : 0,
          minbooking: 1,
          maxbooking: 1,
          ticketdesc: "Internal Ticket",
          eventid: session.eventid,
          status: "internal",
          formid: values.formid,
          usercategory: values.usercategory,
          createdby: session.userid,
          updatedby: session.userid,
        },
      };

      postRequest(
        url,
        body,
        session,
        dispatch,
        (data) => {
          callback({ success: 1, ticketid: data.resource[0].id });
        },
        (error) => {
          callback({ success: 0 });
        }
      );
    }
  } else {
    callback({ success: 1, ticketid: null });
  }
}

export function _uploadSessionBanner(session, imagedata, dispatch, callback) {
  var eventid = session.eventid;
  if (imagedata && imagedata.search(";base64,") > 0) {
    imagedata = imagedata.replace(/^data:image\/[a-z]+;base64,/, "");
    var filename = `eventify/${eventid}/images/session/banner/${randomstring(
      32
    )}.jpg`;
    var imageJson = {
      resource: [
        {
          name: filename,
          type: "file",
          is_base64: true,
          content: imagedata,
        },
      ],
    };

    uploadEncodedFile(
      `${BASE_IMAGES_URL}?check_exist=false`,
      session,
      imageJson,
      dispatch,
      (data) => {
        callback({ success: 1, data: data });
      },
      (error) => {
        callback({ success: 0 });
      }
    );
  } else if (imagedata && imagedata != "") {
    callback({ success: 1, data: { path: imagedata } });
  } else {
    callback({ success: 1, data: { path: null } });
  }
}

export function _uploadAttachedFiles(session, uploadFiles, dispatch, callback) {
  var promiseArray = [];
  var eventid = session.eventid;
  _.map(uploadFiles, (item, index) => {
    promiseArray.push(
      new Promise((resolve, reject) => {
        var file = item.file;
        var name = item.filename;
        var n = file.search(";base64,");
        if (n > 0) {
          var content = file.split(";base64,")[1];
          var fileCustomName = name.substr(0, name.lastIndexOf("."));
          var fileType = name.split(".").pop();

          var filename = `eventify/${eventid}/files/sessions/${fileCustomName}_${randomstring(
            32
          )}.${fileType}`;
          var imageJson = {
            resource: [
              {
                name: filename,
                type: "file",
                is_base64: true,
                content: content,
              },
            ],
          };
          uploadEncodedFile(
            `${BASE_IMAGES_URL}?check_exist=false`,
            session,
            imageJson,
            dispatch,
            (data) => {
              uploadFiles[index].file = data.name;
              resolve();
            },
            (error) => {
              // callback({success:2, message:error});
            }
          );
        } else if (file == "") {
          uploadFiles[index].file = null;
          resolve();
        } else {
          uploadFiles[index].file = file;
          resolve();
        }
      })
    );
    // console.log('upload... ', index)
  });
  // console.log('upload...', promiseArray)
  Promise.all(promiseArray).then(() => {
    // console.log('upload...callback')
    callback({ ...uploadFiles });
  });
}

export function addAdditionalSpeakerAssociation(
  additionalspeakers,
  session,
  scheduledateid,
  callback
) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/sessionspeakers`;

  var json = { resource: additionalspeakers };
  var response = axios.post(url, json, getHeaders(session));

  return (dispatch) => {
    response
      .then(({ data }) => {
        // dispatch(fetchAndRefreshScheduleData(session,scheduledateid));
        var returnData = { error: 0, data: data };
        callback(returnData);
      })
      .catch((error) => {
        var returnData = { error: 1, data: error };
        callback(returnData);
      });
  };
}

export function deleteAdditionalSpeaker(speaker, scheduledateid, session) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/sessionspeakers/${speaker.id}`;
  return (dispatch) => {
    deleteRequest(
      url,
      session,
      dispatch,
      (data) => {
        dispatch(fetchAndRefreshScheduleData(session, scheduledateid));
      },
      (error) => {}
    );
  };
}

export function deleteAdditionalSpeakerBySession(
  sessionid,
  eventid,
  scheduledateid,
  session,
  callback
) {
  var filter = encodeURI(
    `filter=((sessionid=${sessionid}) AND (eventid=${eventid}))`
  );
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/sessionspeakers?${filter}`;

  return (dispatch) => {
    deleteRequest(
      url,
      session,
      dispatch,
      (data) => {
        // dispatch(fetchAndRefreshScheduleData(session,scheduledateid));
        var returnData = { error: 0, data: data };
        callback(returnData);
      },
      (error) => {
        var returnData = { error: 1, error: error };
        callback(returnData);
      }
    );
  };
}

export function updateAdditionalSpeaker(speaker, scheduledateid, session) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/sessionspeakers`;

  var json = { resource: speaker };
  var response = axios.patch(url, json, getHeaders(session));
  return (dispatch) => {
    response
      .then(({ data }) => {
        dispatch(fetchAndRefreshScheduleData(session, scheduledateid));
      })
      .catch((error) => {});
  };
}

export function addAdditionalSpeaker(speaker, scheduledateid, session) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/sessionspeakers`;

  var json = { resource: speaker };
  var response = axios.post(url, json, getHeaders(session));
  return (dispatch) => {
    response
      .then(({ data }) => {
        dispatch(fetchAndRefreshScheduleData(session, scheduledateid));
      })
      .catch((error) => {});
  };
}

export function addMultipleScheduleSession(
  scheduleSessions,
  uploadFiles,
  session,
  refresh,
  callback
) {
  //debugger;
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/session`;

  return (dispatch) => {
    _uploadAttachedFiles(session, uploadFiles, dispatch, (attachments) => {
      var json = [];
      _.map(scheduleSessions, (item) => {
        json.push({
          ...item,
          file1: attachments[0].file,
          file2: attachments[1].file,
          file3: attachments[2].file,
          file4: attachments[3].file,
          file5: attachments[4].file,
        });
      });

      var sessionJson = { resource: json };
      var response = axios.post(url, sessionJson, getHeaders(session));

      response
        .then(({ data }) => {
          // if(refresh)
          //   dispatch(fetchAndRefreshScheduleData(session,scheduleSessions[0].scheduledateid));
          var returnData = { error: 0, data: data };
          callback(returnData);
        })
        .catch((error) => {
          var returnData = { error: 1, data: error };
          callback(returnData);
        });
    });
  };
}

export function selectScheduleDate(date) {
  return {
    type: SELECT_SCHEDULE_DATE,
    payload: date,
  };
}

export function openTrackModal(status, trackObject = {}) {
  return {
    type: OPEN_TRACK_MODAL,
    payload: { status: status, track: trackObject },
  };
}

export function openSessionModal(obj) {
  return {
    type: OPEN_SESSION_MODAL,
    payload: obj,
  };
}

export function openPrivateSessionUserModal(obj) {
  return {
    type: OPEN_SESSION_PRIVATE_USER_MODAL,
    payload: obj,
  };
}

export function uploadContentFile(fileData, type, callback) {
  var formData = new FormData();
  formData.append("name", fileData.filename);
  formData.append("file", fileData.file);

  return (dispatch) => {
    var config = {
      onUploadProgress: function (progressEvent) {
        var percentCompleted = progressEvent.loaded / progressEvent.total;
        dispatch({
          type: UPDATE_FILES_UPLOAD_PROGRESS,
          payload: percentCompleted * 100,
        });
      },
      headers: { "content-type": "multipart/form-data" },
    };

    axios
      .post(`${INSTANCE_URL}/upload.php?filename=${type}`, formData, config)
      .then(function (res) {
        var filePath = res.data;
        callback(filePath);
      })
      .catch(function (err) {
        //Reset the upload progress
        dispatch({ type: UPDATE_FILES_UPLOAD_PROGRESS, payload: -1 });

        //Dispatch to tell there was an error
        dispatch({ type: FILES_UPLOAD_FAILED, payload: true });
      });
  };
}

export function openFeaturesModal(showModal) {
  return { type: FEATURES_MODAL, payload: showModal };
}

export function contentAddRemoveModal(obj) {
  return { type: CONTENT_ADD_REMOVE_MODAL, payload: obj };
}

export function clearSingleSessionAssociatedUsers() {
  return (dispatch) => {
    dispatch({ type: SESSION_ASSOCIATED_USERS, payload: {} });
  };
}

export function fetchSingleSessionAssociatedUsers(session, values, callback) {
  var filter = encodeURI(
    `(sessionid=${values.sessionid})AND(eventid=${session.eventid})`
  );
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/appuser_access?related=appuser_by_appuserid&appuser_by_appuserid.fields=appuserid,email,username,usercategory&filter=(${filter})`;

  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (response) => {
        //console.log(response);
        dispatch({
          type: SESSION_ASSOCIATED_USERS,
          payload: { data: response.resource },
        });
        callback({ success: 1, data: response.resource });
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}

export function deleteAssociatedUserBySession(
  sessionid,
  eventid,
  scheduledateid,
  session,
  callback
) {
  var filter = encodeURI(
    `filter=((sessionid=${sessionid}) AND (eventid=${eventid}))`
  );
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/appuser_access?${filter}`;

  return (dispatch) => {
    deleteRequest(
      url,
      session,
      dispatch,
      (data) => {
        // dispatch(fetchAndRefreshScheduleData(session,scheduledateid));
        var returnData = { error: 0, data: data };
        callback(returnData);
      },
      (error) => {
        var returnData = { error: 1, error: error };
        callback(returnData);
      }
    );
  };
}

export function addAssociatedUsers(users, session, scheduledateid, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/appuser_access`;
  var json = { resource: users };

  return (dispatch) => {
    postRequest(
      url,
      json,
      session,
      dispatch,
      (response) => {
        dispatch(fetchAndRefreshScheduleData(session, scheduledateid));
        var returnData = { error: 0, data: response };
        callback(returnData);
      },
      (error) => {
        var returnData = { error: 1, data: error };
        callback(returnData);
      }
    );
  };
}

export function updatePrivateAssociateUsers(
  newusers,
  delusers,
  session,
  scheduledateid,
  callback
) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/appuser_access`;
  var json = { resource: newusers };

  return (dispatch) => {
    if (newusers.length > 0 && delusers.length > 0) {
      postRequest(
        url,
        json,
        session,
        dispatch,
        (response) => {
          var body = {
            resource: delusers,
          };
          deleteBulkRequest(
            url,
            session,
            body,
            dispatch,
            (res) => {
              dispatch(fetchAndRefreshScheduleData(session, scheduledateid));
              var returnData = { error: 0, data: res };
              callback(returnData);
            },
            (error) => {
              callback({ error: 0, message: error });
            }
          );
        },
        (error) => {
          var returnData = { error: 1, data: error };
          callback(returnData);
        }
      );
    } else if (delusers.length > 0 && newusers.length == 0) {
      var body = {
        resource: delusers,
      };
      deleteBulkRequest(
        url,
        session,
        body,
        dispatch,
        (res) => {
          dispatch(fetchAndRefreshScheduleData(session, scheduledateid));
          var returnData = { error: 0, data: res };
          callback(returnData);
        },
        (error) => {
          callback({ error: 0, message: error });
        }
      );
    } else if (delusers.length == 0 && newusers.length > 0) {
      postRequest(
        url,
        json,
        session,
        dispatch,
        (response) => {
          dispatch(fetchAndRefreshScheduleData(session, scheduledateid));
          var returnData = { error: 0, data: response };
          callback(returnData);
        },
        (error) => {
          var returnData = { error: 1, data: error };
          callback(returnData);
        }
      );
    } else {
      dispatch(fetchAndRefreshScheduleData(session, scheduledateid));
      var returnData = { error: 0 };
      callback(returnData);
    }
  };
}

export function updateSessionFiles(file) {
  return (dispatch) => {
    dispatch({ type: UPDATE_SESSION_FILES, payload: file });
  };
}

export function clearSingleSessionRSVPUsers() {
  return (dispatch) => {
    dispatch({ type: SESSION_RSVP_USERS, payload: {} });
  };
}

export function fetchSingleSessionRSVPUsers(session, values, callback) {
  var filter = encodeURI(
    `(sessionid=${values.sessionid})AND(eventid=${session.eventid})`
  );
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/session_rsvp?related=appuser_by_appuserid&appuser_by_appuserid.fields=appuserid,email,username&filter=(${filter})`;

  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (response) => {
        // console.log(response);
        dispatch({
          type: SESSION_RSVP_USERS,
          payload: { data: response.resource },
        });
        callback({ success: 1, data: response.resource });
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}

export function addRsvpUsers(users, session, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/session_rsvp`;
  var json = { resource: users };

  return (dispatch) => {
    postRequest(
      url,
      json,
      session,
      dispatch,
      (response) => {
        var returnData = { error: 0, data: response };
        callback(returnData);
      },
      (error) => {
        var returnData = { error: 1, data: error };
        callback(returnData);
      }
    );
  };
}

export function updateRSVPUsers(newusers, delusers, session, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/session_rsvp`;
  var json = { resource: newusers };

  return (dispatch) => {
    if (newusers.length > 0 && delusers.length > 0) {
      postRequest(
        url,
        json,
        session,
        dispatch,
        (response) => {
          var body = {
            resource: delusers,
          };
          deleteBulkRequest(
            url,
            session,
            body,
            dispatch,
            (res) => {
              var returnData = { error: 0, data: res };
              callback(returnData);
            },
            (error) => {
              callback({ error: 0, message: error });
            }
          );
        },
        (error) => {
          var returnData = { error: 1, data: error };
          callback(returnData);
        }
      );
    } else if (delusers.length > 0 && newusers.length == 0) {
      var body = {
        resource: delusers,
      };
      deleteBulkRequest(
        url,
        session,
        body,
        dispatch,
        (res) => {
          var returnData = { error: 0, data: res };
          callback(returnData);
        },
        (error) => {
          callback({ error: 0, message: error });
        }
      );
    } else if (delusers.length == 0 && newusers.length > 0) {
      postRequest(
        url,
        json,
        session,
        dispatch,
        (response) => {
          var returnData = { error: 0, data: response };
          callback(returnData);
        },
        (error) => {
          var returnData = { error: 1, data: error };
          callback(returnData);
        }
      );
    } else {
      var returnData = { error: 0 };
      callback(returnData);
    }
  };
}

export function downloadSchedules(session, callback) {
  var url = `${INSTANCE_URL}/api/v2/custom_script`;
  var body = {
    eventid: session.eventid,
    type: "downloadschedules",
    // type:'downloadschedules_old'
  };
  return (dispatch) => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      (response) => {
        // console.log(response);
        callback({
          success: 1,
          successS3: response.successS3,
          filename: response.pdfname,
        });
      },
      (error) => {
        //callback({success: 0, message: error});
      }
    );
  };
}

export function getEventCode(session, callback) {
  var filter = encodeURI(`filter=(eventid=${session.eventid})`);
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/event?${filter}`;

  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (response) => {
        //console.log(response);
        callback({ success: 1, eventcode: response.resource[0]["eventcode"] });
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}

export function sessionWeekDays(days) {
  return (dispatch) => {
    dispatch({ type: SESSION_WEEKDAYS, payload: days });
  };
}

export function eventDefaultTrack(session, callback) {
  var filter = encodeURI(`filter=(eventid=${session.eventid})`);
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/scheduletracks?${filter}`;

  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (response) => {
        //console.log(response);
        dispatch({ type: SESSION_DEFAULT_TRACK, payload: response.resource });
        callback({ success: 1, data: response.resource });
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}

export function fetchActiveDateSessions(session, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventifyscript/fetcheventsessions`;
  var body = { eventid: session.eventid };

  return (dispatch) => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      (response) => {
        // console.log("response", response);

        if (response.success == 1) {
          dispatch({
            type: ACTIVE_DATE_ALL_SESSION,
            payload: { data: response.data, count: response.count },
          });
          callback({ success: 1, response: response });
        }
      },
      (error) => {}
    );
  };
}

export function fetchAdditionalSessions(session, callback) {
  let filter = encodeURI(
    `(eventid=${session.eventid})AND((sessiontype=additional)OR(sessiontype=addprivate))`
  );
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/session?filter=(${filter})&order=createdon%20DESC`;

  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (response) => {
        // console.log("response :- ", response);

        dispatch({
          type: ALL_ADDITIONAL_SESSIONS,
          payload: { data: response.resource, count: response.meta.count },
        });

        callback({
          success: 1,
          data: response.resource,
          count: response.meta.count,
        });
      },
      (error) => {}
    );
  };
}

export function updateTicketsSession(session, values, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/session`;
  var body = { resource: values };

  return (dispatch) => {
    patchRequest(
      url,
      body,
      session,
      dispatch,
      (response) => {
        callback({ success: 1, data: response });
      },
      (error) => {
        callback({ success: 0, data: "" });
      }
    );
  };
}

export function updateSessionZoom(obj) {
  return (dispatch) => {
    dispatch({ type: SESSION_SCREEN_ZOOM, payload: obj });
  };
}

export function manageNoTrack(session, scheduledate, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventifyscript_support`;

  return (dispatch) => {
    postRequest(
      url,
      {
        eventid: session.eventid,
        scheduledate: scheduledate,
        type: "updatenotrack",
      },
      session,
      dispatch,
      (response) => {
        if (response.success) {
          callback({ status: 1, data: response });
          dispatch(fetchAndRefreshScheduleData(session, scheduledate));
        } else {
          callback({ status: 0, data: response });
        }
      },
      (error) => {}
    );
  };
}

// manages redux for bulk edit modal display (no data passed)
export const handleBulkEditModal = (option) => {
  return (dispatch) =>
    dispatch({ type: BULLKEDIT_MODAL_CONTROL, payload: option });
};

export const handleBulkEditUpdate = (session, actionValue, callback) => {
  let table_url = `${INSTANCE_URL}/api/v2/eventify/_table/`, // common table url
    session_url = `${table_url}session`, // session table url
    sessSpeaker_url = `${table_url}sessionspeakers`, // sessionspeaker table url
    speakerDelete_url = `${sessSpeaker_url}?filter=${encodeURI(
      `((eventid=${session.eventid})AND(sessionid IN (${actionValue.speakerDelete})))`
    )}`; // sessionspeaker table delete url filtered with session ids

  // Chosen flow:
  // If UPDATE requires then:
  //  1. UPDATE session
  //  2. IF actionValue.speakerDelete (comma seperated sessionid string) != blank then DELETE all sessionspeaker filtered by selected sessionid
  //  3. IF actionValue.speakerCreate (array of sessionspeaker objects) !empty then CREATE all sessionspeaker
  //  4. If CREATE requires, then CREATE sessions (Session-speakers are assigned as relation within array objects)
  // ELSE if CREATE requires:
  //  CREATE sessions (Session-speakers are assigned as relation within array objects)

  // If nothing to update (If happens check bulk edit submission, SHOULD NOT HAPPEN)
  // if (_.isEmpty(actionValue.session_update_resource) || _.isEmpty(actionValue.session_create_resource)) return (dispatch) => {};

  if (!_.isEmpty(actionValue.session_update_resource)) {
    return (dispatch) => {
      patchRequest(
        // UPDATE _table/session
        session_url,
        { resource: actionValue.session_update_resource },
        session,
        dispatch,
        (session_res) => {
          if (actionValue.speakerDelete !== "") {
            deleteRequest(
              // DELETE _table/sessionspeaker FILTER BY sessionid
              speakerDelete_url,
              session,
              dispatch,
              (speaker_del_res) => {
                if (!_.isEmpty(actionValue.speakerCreate)) {
                  postRequest(
                    // CREATE _table/sessionspeaker
                    sessSpeaker_url,
                    { resource: actionValue.speakerCreate },
                    session,
                    dispatch,
                    (speaker_ins_res) => {
                      if (!_.isEmpty(actionValue.session_create_resource)) {
                        postRequest(
                          session_url,
                          { resource: actionValue.session_create_resource },
                          session,
                          dispatch,
                          (session_create_res) => {
                            callback({
                              success: 1,
                              sessionspeaker_success: 1,
                              session_create: 1,
                              case: "update-speaker_insert-create",
                            });
                          },
                          (session_create_err) => {
                            callback({
                              success: 1,
                              sessionspeaker_success: 1,
                              session_create: 0,
                              error: session_create_err,
                              case: "update-speaker_insert-create",
                            });
                          }
                        );
                      } else {
                        callback({
                          success: 1,
                          sessionspeaker_success: 1,
                          session_create: 2,
                          case: "update-speaker_insert",
                        });
                      }
                    },
                    (speaker_ins_err) => {
                      callback({
                        success: 1,
                        sessionspeaker_success: 0,
                        session_create: 2,
                        error: speaker_ins_err,
                        case: "update-speaker_insert",
                      });
                    }
                  );
                } else {
                  if (!_.isEmpty(actionValue.session_create_resource)) {
                    postRequest(
                      session_url,
                      { resource: actionValue.session_create_resource },
                      session,
                      dispatch,
                      (session_create_res) => {
                        callback({
                          success: 1,
                          sessionspeaker_success: 1,
                          session_create: 1,
                          case: "update-speaker_delete-create",
                        });
                      },
                      (session_create_err) => {
                        callback({
                          success: 1,
                          sessionspeaker_success: 1,
                          session_create: 0,
                          error: session_create_err,
                          case: "update-speaker_delete-create",
                        });
                      }
                    );
                  } else {
                    callback({
                      success: 1,
                      sessionspeaker_success: 1,
                      session_create: 2,
                      case: "update-speaker_delete",
                    });
                  }
                }
              },
              (speaker_del_err) => {
                callback({
                  success: 1,
                  sessionspeaker_success: 0,
                  session_create: 2,
                  error: speaker_del_err,
                  case: "update-speaker_delete",
                });
              }
            );
          } else {
            if (!_.isEmpty(actionValue.session_create_resource)) {
              postRequest(
                session_url,
                { resource: actionValue.session_create_resource },
                session,
                dispatch,
                (session_create_res) => {
                  callback({
                    success: 1,
                    sessionspeaker_success: 2,
                    session_create: 1,
                    case: "update-create",
                  });
                },
                (session_create_err) => {
                  callback({
                    success: 1,
                    sessionspeaker_success: 2,
                    session_create: 0,
                    error: session_create_err,
                    case: "update-create",
                  });
                }
              );
            } else {
              callback({
                success: 1,
                sessionspeaker_success: 2,
                session_create: 2,
                case: "update",
              });
            }
          }
        },
        (session_err) => {
          callback({
            success: 0,
            sessionspeaker_success: 2,
            session_create: 2,
            error: session_err,
            case: "update",
          });
        }
      );
    };
  } else if (!_.isEmpty(actionValue.session_create_resource)) {
    return (dispatch) => {
      postRequest(
        session_url,
        { resource: actionValue.session_create_resource },
        session,
        dispatch,
        (session_res) => {
          callback({
            success: 2,
            sessionspeaker_success: 2,
            session_create: 1,
            case: "create",
          });
        },
        (session_err) => {
          callback({
            success: 2,
            sessionspeaker_success: 2,
            session_create: 0,
            error: session_err,
            case: "create",
          });
        }
      );
    };
  } else return (dispatch) => {};
};

export const createBulkTracks = (session, propsValue, callback) => {
  let postUrl = `${INSTANCE_URL}/api/v2/eventify/_table/scheduletracks`,
    postBody = [];

  // NOTE: Expected format of propsValue should be { <CreateSelect_NewTrack_ID> : {eventid, scheduledateid, trackname}, ... }
  _.map(propsValue, (item, itemIndex) => {
    postBody.push(item);
  });

  return (dispatch) => {
    postRequest(
      postUrl,
      { resource: postBody },
      session,
      dispatch,
      (res) => {
        let resBody = {},
          counter = 0;
        if (res.resource.length) {
          _.map(propsValue, (item, itemKey) => {
            resBody[itemKey] = res.resource[counter];
            counter++;
          });

          callback({ success: 1, data: resBody });
        }
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
};
